import { addGETParams } from '../../config'
import ax from '../api'
import axInsecure from '../api-insecure'

/*
 * setMeeting - Set a meeting item on the server
 * @param {string} meetingId - The id of the meeting item
 * @param {object} full - The full object of the meeting item
 * @returns {object} The response from the server
 */
export const setMeeting = async (meetingId, full) => {
	// Convert full object to JSON string
	const fullStr = JSON.stringify(full)
	const _url = addGETParams(`/meetings/set.php`, {
		id: meetingId,
		full: fullStr
	})
	return await axInsecure.post(_url)
}

/*
 * getMeetingList - Retrieve a list of meeting items from the server
 * @param {object} params - Parameters to filter and paginate the meeting list
 * @returns {object} The response from the server containing the list of meetings
 */
export const getMeetingList = async (params) => {
	const _url = addGETParams(`/meetings/lst.php`, params)
	return await ax.post(_url)
}

/*
 * getMeeting - Retrieve a specific meeting item from the server
 * @param {string} meetingId - The id of the meeting item to retrieve
 * @returns {object} The response from the server containing the meeting item
 */
export const getMeeting = async (meetingId) => {
	const _url = addGETParams(`/meetings/get.php`, {
		id: meetingId
	})
	return await ax.post(_url)
}
